export default () => {
  const standalone = Boolean(window.matchMedia("(display-mode: standalone)").matches) || Boolean(window.navigator.standalone);
  const { userAgent } = window.navigator;
  const appleDevice = Boolean(userAgent.match(/iPad/i)) || Boolean(userAgent.match(/iPhone/i));
  return standalone || appleDevice;
};
